module.exports = __webpack_public_path__ + "static/media/mediacom.0691478a.gif";